import { connect } from 'react-redux'
import { downloadTicketsAndVouchers } from 'services/downloadFiles/reducer'
import { sendSms } from 'services/sendSms/reducer'

const mapStateToProps = (state) => {
    return {
        order: state?.pages?.paymentVerify?.order,
    }
}

const hocThanksForOrder = (InnerComponent) =>
    connect(mapStateToProps, { sendSms, downloadTicketsAndVouchers })(InnerComponent)

export default hocThanksForOrder
